import React, { PropTypes } from 'react';
import { Navbar } from 'react-bootstrap';
import { IndexLink, Link } from 'react-router';
import './Sale.less';

class Sale extends React.Component {
   render() {
      return (
         <div className="Sale" >
            <Navbar className="Sale_Nav" >
               <Navbar.Header >
                  <Navbar.Brand >
                     <Link to="/sale/" activeStyle={{ color: 'red' }} >Sale</Link >
                  </Navbar.Brand >
               </Navbar.Header >
               <ul className="nav navbar-nav" >
                  <li >
                     <IndexLink to="/sale/" activeStyle={{ color: 'red' }} >All</IndexLink >
                  </li >
                  <li >
                     <Link to="/sale/newSale" activeStyle={{ color: 'red' }} >New</Link >
                  </li >
                  <li className="right">
                     <Link to="/sale/saleDueBill" activeStyle={{ color: 'red' }} >Contacts Due</Link >
                  </li >
                  <li >
                     <Link to="/sale/saleUnknownDueBill" activeStyle={{ color: 'red' }} >Unknown Due</Link >
                  </li >
               </ul >
            </Navbar >
            {this.props.children}
         </div >
      );
   }
}

Sale.propTypes = {
   children: PropTypes.object
};

export default Sale;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/Sale.js
 **/